module.exports = __webpack_public_path__ + "static/media/jean.81a34e1a.jpg";